import { render, staticRenderFns } from "./BrandFormCourier.vue?vue&type=template&id=0b580d4a&"
import script from "./BrandFormCourier.vue?vue&type=script&lang=js&"
export * from "./BrandFormCourier.vue?vue&type=script&lang=js&"
import style0 from "./BrandFormCourier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports